import { Icon } from '@iconify/react/dist/iconify.js'
import React from 'react'
import { Link } from 'react-router-dom'

const FeaturedCreatorsOne = () => {
    return (
        <div className="col-xxl-12 col-md-6">
            <div className="card h-100">
                <div className="card-header border-bottom d-flex align-items-center flex-wrap gap-2 justify-content-between">
                    <h6 className="fw-bold text-lg mb-0">Featured Creators</h6>
                    <Link
                        to="#"
                        className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                    >
                        View All
                        <Icon
                            icon="solar:alt-arrow-right-linear"
                            className="icon"
                        />
                    </Link>
                </div>
                <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between gap-8 flex-wrap">
                        <div className="d-flex align-items-center">
                            <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSoiOCMGnKHmY_TOMEWtusXaj9n_ui2TUDJWJdPYRVPrESZNtU9sF53Vgla22j-Tx7RvZY&usqp=CAU&quot"
                                alt=""
                                className="flex-shrink-0 me-12 w-40-px h-40-px rounded-circle me-12"
                            />
                            <div className="flex-grow-1">
                                <h6 className="text-md mb-0 fw-semibold">Aggregator Admin</h6>
                                <span className="text-sm text-secondary-light fw-normal">
                                    Owned by Admin
                                </span>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn btn-outline-primary-600 px-24 rounded-pill"
                        >
                            Follow
                        </button>
                    </div>
                    <div className="mt-24">
                        <div className="row gy-3">
                            <div className="col-sm-6 col-xs-6">
                                <div className="nft-card bg-base radius-16 overflow-hidden shadow-4">
                                    <div className="radius-16 overflow-hidden">
                                        <img
                                            src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/best-cover-album-music-art-trap-mixtape-rap-design-template-5cc060d60ab10c800b783bfd4635d71f.webp?ts=1739800948"
                                            alt=""
                                            className="w-100 h-100 object-fit-cover"
                                        />
                                    </div>
                                    <div className="p-12">
                                        <h6 className="text-md fw-bold text-primary-light mb-12">
                                            DJ Keblinger - Puasa
                                        </h6>
                                        <div className="d-flex align-items-center gap-8">
                                            <img
                                                src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/best-cover-album-music-art-trap-mixtape-rap-design-template-5cc060d60ab10c800b783bfd4635d71f.webp?ts=1739800948"
                                                className="w-28-px h-28-px rounded-circle object-fit-cover"
                                                alt=""
                                            />
                                            <span className="text-sm text-secondary-light fw-medium">
                                                Diputar 3.25 kali
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-xs-6">
                                <div className="nft-card bg-base radius-16 overflow-hidden shadow-4">
                                    <div className="radius-16 overflow-hidden">
                                        <img
                                            src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/black-mixtape-cover-album-cover-design-template-dcc9e2ffae0d03fcff7296f35b37400e.webp?ts=1742842944"
                                            alt=""
                                            className="w-100 h-100 object-fit-cover"
                                        />
                                    </div>
                                    <div className="p-12">
                                        <h6 className="text-md fw-bold text-primary-light mb-12">
                                            Opick - Ya Ramadhan
                                        </h6>
                                        <div className="d-flex align-items-center gap-8">
                                            <img
                                                src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/brown-best-cover-album-music-art-trap-mixtap-design-template-f0ff22ebef9b17508ca5c2d55b4c40a4.webp?ts=1736778809"
                                                className="w-28-px h-28-px rounded-circle object-fit-cover"
                                                alt=""
                                            />
                                            <span className="text-sm text-secondary-light fw-medium">
                                                Diputar 3.289 kali
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-xs-6">
                                <div className="nft-card bg-base radius-16 overflow-hidden shadow-4">
                                    <div className="radius-16 overflow-hidden">
                                        <img
                                            src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/black-mixtape-cover-album-cover-design-template-dcc9e2ffae0d03fcff7296f35b37400e.webp?ts=1742842944"
                                            alt=""
                                            className="w-100 h-100 object-fit-cover"
                                        />
                                    </div>
                                    <div className="p-12">
                                        <h6 className="text-md fw-bold text-primary-light mb-12">
                                            Opick - Ya Ramadhan
                                        </h6>
                                        <div className="d-flex align-items-center gap-8">
                                            <img
                                                src="https://static.vecteezy.com/system/resources/previews/011/778/457/non_2x/music-logo-icon-free-vector.jpg"
                                                className="w-28-px h-28-px rounded-circle object-fit-cover"
                                                alt=""
                                            />
                                            <span className="text-sm text-secondary-light fw-medium">
                                                Diputar 3.289 kali
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-xs-6">
                                <div className="nft-card bg-base radius-16 overflow-hidden shadow-4">
                                    <div className="radius-16 overflow-hidden">
                                        <img
                                            src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/best-cover-album-music-art-trap-mixtape-rap-design-template-5cc060d60ab10c800b783bfd4635d71f.webp?ts=1739800948"
                                            alt=""
                                            className="w-100 h-100 object-fit-cover"
                                        />
                                    </div>
                                    <div className="p-12">
                                        <h6 className="text-md fw-bold text-primary-light mb-12">
                                            Opick - Ya Ramadhan
                                        </h6>
                                        <div className="d-flex align-items-center gap-8">
                                            <img
                                                src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/brown-best-cover-album-music-art-trap-mixtap-design-template-45a1d61d56137d3f3c5e26a361780b27.webp?ts=1740144752"
                                                className="w-28-px h-28-px rounded-circle object-fit-cover"
                                                alt=""
                                            />
                                            <span className="text-sm text-secondary-light fw-medium">
                                                Diputar 3.289 kali
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeaturedCreatorsOne